import styled from 'styled-components';

export const LabelStyle = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #333;
  line-height: 2;
`;

export const Label = (props) => {
  const { children, isRequired = false, ...others } = props;
  return (
    <LabelStyle {...others}>
      {children}
      {isRequired && <span style={{ color: 'red' }}>*</span>}
    </LabelStyle>
  );
};
